import { useMemo } from 'react';
import { useAuthContext } from '@/providers';

// ==============================|| LOGGED USER LOCATION - autocomplete formulare ||============================== //
// Dacă userul logat are cel puțin o administrație cu locație (județ / UAT), câmpurile
// care coincid din formularele aplicației se autocompletează cu aceste valori — ca
// DEFAULT editabil, nu blocat. Se folosește PRIMA administrație care are o locație cu
// județ (convenția locations[0] din restul aplicației).

// Forma administrațiilor de pe userul logat (api/users/me e spread în profil, dar
// IUser nu declară câmpul) — tipare structurală minimă.
interface LoggedUserAdministrationLocation {
	county?: { id: number; name: string } | null;
	uat?: { id: number; name: string } | null;
}

interface LoggedUserAdministration {
	id?: number;
	name?: string;
	locations?: LoggedUserAdministrationLocation[] | null;
}

export interface LoggedUserLocation {
	administrationId?: number;
	administrationName: string;
	countyId?: number;
	countyName: string;
	uatId?: number;
	uatName: string;
}

export function useLoggedUserLocation(): LoggedUserLocation | null {
	const { user } = useAuthContext();

	return useMemo(() => {
		const administrations =
			(user as { administrations?: LoggedUserAdministration[] } | undefined)
				?.administrations ?? [];
		for (const administration of administrations) {
			const location = (administration?.locations ?? []).find(
				(item) => item?.county?.name
			);
			if (location) {
				return {
					administrationId: administration.id,
					administrationName: administration.name ?? '',
					countyId: location.county?.id,
					countyName: location.county?.name ?? '',
					uatId: location.uat?.id,
					uatName: location.uat?.name ?? ''
				};
			}
		}
		return null;
	}, [user]);
}
